import { CheckCircle2 } from 'lucide-react';
import { useOrders } from '../context/OrdersContext';
import styles from './Toast.module.css';

export default function Toast() {
  const { toast } = useOrders();
  if (!toast) return null;
  return (
    <div className={styles.toast} key={toast.id}>
      <CheckCircle2 size={16} />
      <span>{toast.message}</span>
    </div>
  );
}
